import { Injectable, inject } from '@angular/core';
import { Router } from '@angular/router';
import {TokenStorageService} from '@services/local-storage/token-storage/token-storage.service';
import {SharedDataService} from '@services/share-data/share-data.service';
import {UserStorageService} from '@services/local-storage/user-storage/user-storage.service';
import { Subject, takeUntil, Subscription } from 'rxjs';
import {AuthService} from '@services/api/auth/auth.service';
import {CryptService} from '@services/crypt/crypt.service';

@Injectable({
  providedIn: 'root'
})
export class LogoutService {
  private router = inject(Router);
  private token_storage_service = inject(TokenStorageService);
  private user_storage_service = inject(UserStorageService);
  private share_data_service = inject(SharedDataService);
  private crypto_service = inject(CryptService)
  private destroy$ = new Subject<void>();
  private auth_service = inject(AuthService);
  private email: string = '';
  private emailSubscription: Subscription | undefined;

  constructor() {}

  async ngOnInit(): Promise<void> {
    this.emailSubscription = this.share_data_service.data$.subscribe(email => {
      if (email) {
        this.email = email;
      }
    });
  }

  logout(): void {
    this.clearClientSideData();
  }

  private clearClientSideData(): void {
    this.token_storage_service.removeAllTokensStorage();
    this.user_storage_service.removeUserStorage();
    this.share_data_service.clearData();
    this.router.navigate(['/login']);
  }
}
